import dayjs from 'dayjs'
import { PAYMENT_TYPES_LABELS, SELLING_TYPES, SELLING_TYPES_LABELS } from '@/constants/order-constants'
import i18n from '@/libs/i18n/index'
import store from '@/store'
import { WEBAPP_URL } from '@/constants/config'
import { formatCarInfo, hasCarInfo } from '@/views/admin/management/orders/utils/car-info-helper'

export default function getReceiptInfo(order) {
  const items = order?.order_lines ?? []

  const discountAmount = order.discount_amount ?? items.reduce((prev, item) => prev + (item.quantity * (item?.discount_amount || 0)), 0)
  const isDelivery = order.type_key === SELLING_TYPES.DELIVERY
  const orderType = order?.takeaway ? 'orders.takeaway' : SELLING_TYPES_LABELS[order.type_key]
  const paymentType = PAYMENT_TYPES_LABELS[order.payment_type_key]
  const orderTypeDetails = (() => {
    const { car_info, table, address } = order

    if (order.type_key === SELLING_TYPES.DINE_IN && table) {
      if (typeof table === 'string') {
        return table
      }
      return `${table?.name} ${table?.floor ? `, ${table?.floor?.name}` : ''}`
    }

    if (order.type_key === SELLING_TYPES.DELIVERY && address && (typeof address === 'object') && !Array.isArray(address)) {
      const formFields = ['address_label', 'city', 'street', 'block', 'area', 'parking', 'note', 'house_number', 'office_number', 'building', 'avenue', 'floor', 'apartment', 'paci', 'special_direction']
      return formFields.filter(field => address[field])
        .map(field => {
          const isShort = ['city', 'apartment', 'note', 'street'].includes(field)
          const fieldKey = isShort ? `${field}-short` : field
          return `${i18n.t(`delivery.address-form-fields.${fieldKey}`)}: ${address[field]}`
        })
        .join(', ')
    }

    if (order.type_key === SELLING_TYPES.CAR_PICKUP && car_info && (typeof car_info === 'object') && !Array.isArray(car_info) && hasCarInfo(car_info)) {
      return formatCarInfo(car_info)
    }

    return ''
  })()
  const { currency, restaurant_name, reference_id } = store.getters['branches/currentBranch']
  const orderTime = (() => {
    const time = order?.created_at
    if (!time) return ''

    return dayjs(time).format('HH:mm')
  })()
  const orderDate = (() => {
    const time = order?.created_at
    if (!time) return ''

    return dayjs(time).format('DD/MM/YYYY')
  })()
  const scheduledTime = (order.scheduled_at === '-') ? '-' : dayjs(order.scheduled_at).format('DD/MM/YYYY HH:mm')
  const deliveryTime = !order.expected_delivery_time ? '' : dayjs(order.expected_delivery_time).format('HH:mm')
  const originalCurrency = order?.order_lines?.[0]?.currency ?? currency

  return {
    discountAmount,
    isDelivery,
    orderType,
    paymentType,
    orderTypeDetails,
    currency,
    orderTime,
    orderDate,
    scheduledTime,
    deliveryTime,
    originalCurrency: originalCurrency === 'KWD' ? 'KD' : originalCurrency,
    businessName: restaurant_name,
    webappUrl: `${WEBAPP_URL}/${reference_id}`,
  }
}
